/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getCompanyWaProfileImage } from '../fn/company-public-api/get-company-wa-profile-image';
import { GetCompanyWaProfileImage$Params } from '../fn/company-public-api/get-company-wa-profile-image';

@Injectable({ providedIn: 'root' })
export class CompanyPublicApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCompanyWaProfileImage()` */
  static readonly GetCompanyWaProfileImagePath = '/v1/api/ui/public/company/wa-profile/{wabaPhoneId}/image';

  /**
   * Get WhatsApp profile image.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyWaProfileImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyWaProfileImage$Response(params: GetCompanyWaProfileImage$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return getCompanyWaProfileImage(this.http, this.rootUrl, params, context);
  }

  /**
   * Get WhatsApp profile image.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyWaProfileImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyWaProfileImage(params: GetCompanyWaProfileImage$Params, context?: HttpContext): Observable<Blob> {
    return this.getCompanyWaProfileImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
